import React, { useEffect, useState } from 'react';
import { Row, Col, Button } from 'reactstrap';

//Actions
import { actionsTable } from '../../../constants/MaterialTable';

//Api
import usuario_api from '../../../api/usuario_api';
import transportador_api from '../../../api/transportador_api';

//Components
import TextField from 'components/TextField/TextField';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import Loading from '../../../components/Loading/Loading';
import MainCard from '../../../components/MainCard/MainCard';

//Helpers
import { showMessage } from '../../../helpers/message';


function UsuarioExternos() {

    //Estado para controle da tela de novo usuario
    const [usuarioInterno, setUsuarioInterno] = useState({ usuarioInterno_id: null });

    const [listUsuarios, setListUsuarios] = useState([]);

    const [listUsuariosIntegrador_transportador, setListUsuariosIntegrador_transportador] = useState([]);

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState();

    const loadUsuariosIntegrador = () => {
        setLoading(true);
        usuario_api.getListUsuariosIntegrador().then(response => {
            response.data = response.data.map(value => {
                value.label = value.nome;
                value.value = value.id;
                return value;
            });
            setListUsuarios(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }


    const handleRemoveUsuarioInterno = (rowData) => {
        setLoading(true)
        transportador_api.RemoveUsuarioIntegrador(rowData.id)
            .then(response => {
                setUsuarioInterno(null);
                showMessage("Sucesso", "Usuário removido do transportador com sucesso.", "success", () => loadUsuariosIntegradors_transportadores());
            })
            .catch(err => showMessage("Error", err.message, "error", null))
            .finally(() => setLoading(false));
    }

    //Ações da tabela de listagem
    const actions = [
        actionsTable.remover((rowData) => handleRemoveUsuarioInterno(rowData))
    ]

    //cabeçalhos da tabela de listagem
    const headers = [
        { value: "Nome", objectValue: "nome" },
        { value: "CPF / CNPJ", objectValue: "cpfcnpj" },
        { value: "Perfil", objectValue: "perfil" },
        { value: "Status", objectValue: "status" },
    ];

    const handleAdicionarUsuarioIntegrador = () => {
        if (usuarioInterno?.usuarioInterno_id == null) {
            showMessage("Aviso", "Selecione um usuário para adicionar", "warning", null);
            return;
        }

        setLoading(true)
        transportador_api.InsertUsuarioIntegrador(usuarioInterno.usuarioInterno_id)
            .then(response => {
                setUsuarioInterno(null);
                showMessage("Sucesso", "Usuário adicionado ao transportador com sucesso.", "success", () => loadUsuariosIntegradors_transportadores());
            })
            .catch(err => showMessage("Error", err.message, "error", null))
            .finally(() => setLoading(false));
    }

    const onChangeUsuario = (e, select) => {
        const { name } = select;
        setUsuarioInterno({
            ...usuarioInterno,
            [name]: e?.value ? e.value : null
        })
    }

    const loadUsuariosIntegradors_transportadores = () => {
        setLoading(true)
        transportador_api.GetUsuariosIntegradores()
            .then(response => {
                setListUsuariosIntegrador_transportador(response.data)
            })
            .catch(err => showMessage("Error", err.message, "error", null))
            .finally(() => setLoading(false));
    }

    //Carrega todos os usuarios da listagem assim que o componente é iniciado
    useEffect(() => {
        loadUsuariosIntegrador();
        loadUsuariosIntegradors_transportadores();
    }, []);

    return (
        <>
            {loading && <Loading />}
            <MainCard
                noCard
            >
                <Row className="px-0 mx-0">
                    <Col md="12" lg="4">
                        <TextField
                            options={listUsuarios.filter(u => !listUsuariosIntegrador_transportador?.some(x => x.id === u.id))}
                            label={"Usuario integrador"}
                            type="select"
                            name="usuarioInterno_id"
                            value={listUsuarios.filter(v => v.value === usuarioInterno?.usuarioInterno_id)[0]}
                            onChange={onChangeUsuario}
                            searchable
                        />
                    </Col>
                    <Col md="12" lg="4">
                        <br />
                        <Button
                            color='success'
                            className='mt-2 fw-bold bg-gradient'
                            onClick={handleAdicionarUsuarioIntegrador}>
                            + Adicinar
                        </Button>
                    </Col>
                </Row>
                <div className="mt-3">
                    <TabelaListagem
                        title={"Lista de usuários integradores externo"}
                        items={listUsuariosIntegrador_transportador}
                        options={{ print: false, search: true, pagination: true }}
                        headers={headers}
                        actions={actions}
                    />
                </div>
            </MainCard>
        </>
    )
}

export default UsuarioExternos;